module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weekplan"
  }, [(_vm.weeknote !== undefined && _vm.weeknote.length && !_vm.isLoading) ? _c('div', {
    staticClass: "week_note"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.weekNoteWithLineBreaks)
    }
  })]) : _c('div', [(!_vm.anyNotes && !_vm.isLoading) ? _c('span', [_vm._v("\n    " + _vm._s(_vm.$t('vue.public.no_notes')) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('ul', [_vm._l((_vm.eventsWithNotes), function(day) {
    return [(day.lessons.length !== 0) ? _c('li', {
      staticClass: "day_change"
    }, [_c('div', {
      staticClass: "day_change_header"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$filters.dateNoYear(day.date))))])]), _vm._v(" "), _vm._l((day.lessons), function(event) {
      return [_c('d-week-plan-lesson', {
        attrs: {
          "event": event,
          "date": _vm.date
        }
      })]
    })], 2) : _vm._e()]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7906737e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Mobile/WeekPlan/WeekPlan.vue
// module id = 2025
// module chunks = 1